import React from 'react';

import { Icon } from '@chakra-ui/react';

export const BastionHostIcon = props => (
  <Icon viewBox="0 0 60 60" w="full" h="full" color="inherit" {...props}>
    <g>
      <path
        d="M53,41c0-3.859-3.14-7-7-7s-7,3.141-7,7v1h-4v18h22V42h-4V41z M41,41c0-2.757,2.243-5,5-5s5,2.243,5,5v1H41V41z M55,44v14
		H37V44h2h14H55z"
      />
      <path
        d="M45,54.858V56c0,0.553,0.448,1,1,1s1-0.447,1-1v-1.142c1.72-0.447,3-1.999,3-3.858c0-2.206-1.794-4-4-4s-4,1.794-4,4
		C42,52.859,43.28,54.411,45,54.858z M46,49c1.103,0,2,0.897,2,2s-0.897,2-2,2s-2-0.897-2-2S44.897,49,46,49z"
      />
      <path
        d="M10.5,6C8.019,6,6,8.019,6,10.5S8.019,15,10.5,15s4.5-2.019,4.5-4.5S12.981,6,10.5,6z M10.5,13C9.122,13,8,11.879,8,10.5
		S9.122,8,10.5,8S13,9.121,13,10.5S11.878,13,10.5,13z"
      />
      <circle cx="50" cy="9" r="1" />
      <circle cx="46" cy="9" r="1" />
      <circle cx="52" cy="12" r="1" />
      <circle cx="48" cy="12" r="1" />
      <circle cx="42" cy="9" r="1" />
      <circle cx="44" cy="12" r="1" />
      <circle cx="38" cy="9" r="1" />
      <circle cx="40" cy="12" r="1" />
      <circle cx="34" cy="9" r="1" />
      <circle cx="36" cy="12" r="1" />
      <path
        d="M60,16.392V4.608C60,2.067,57.933,0,55.392,0H4.608C2.067,0,0,2.067,0,4.608v11.783C0,17.86,0.703,19.155,1.777,20
		C0.703,20.845,0,22.14,0,23.608v11.783C0,36.86,0.703,38.155,1.777,39C0.703,39.845,0,41.14,0,42.608v11.783
		C0,56.933,2.067,59,4.608,59H30v-2H4.608C3.17,57,2,55.83,2,54.392V42.608C2,41.17,3.17,40,4.608,40H33v-2H4.608
		C3.17,38,2,36.83,2,35.392V23.608C2,22.17,3.17,21,4.608,21h50.783C56.83,21,58,22.17,58,23.608V38h2V23.608
		c0-1.469-0.703-2.764-1.777-3.608C59.297,19.155,60,17.86,60,16.392z M4.608,19C3.17,19,2,17.83,2,16.392V4.608
		C2,3.17,3.17,2,4.608,2h50.783C56.83,2,58,3.17,58,4.608v11.783C58,17.83,56.83,19,55.392,19H4.608z"
      />
      <path
        d="M6,29.5c0,2.481,2.019,4.5,4.5,4.5s4.5-2.019,4.5-4.5S12.981,25,10.5,25S6,27.019,6,29.5z M13,29.5
		c0,1.379-1.122,2.5-2.5,2.5S8,30.879,8,29.5S9.122,27,10.5,27S13,28.121,13,29.5z"
      />
      <circle cx="50" cy="28" r="1" />
      <circle cx="46" cy="28" r="1" />
      <circle cx="52" cy="31" r="1" />
      <circle cx="48" cy="31" r="1" />
      <circle cx="42" cy="28" r="1" />
      <circle cx="44" cy="31" r="1" />
      <circle cx="38" cy="28" r="1" />
      <circle cx="40" cy="31" r="1" />
      <circle cx="34" cy="28" r="1" />
      <circle cx="36" cy="31" r="1" />
      <path
        d="M6,48.5c0,2.481,2.019,4.5,4.5,4.5s4.5-2.019,4.5-4.5S12.981,44,10.5,44S6,46.019,6,48.5z M13,48.5
		c0,1.379-1.122,2.5-2.5,2.5S8,49.879,8,48.5S9.122,46,10.5,46S13,47.121,13,48.5z"
      />
    </g>
  </Icon>
);
